import { useTranslation } from 'react-i18next';
import { generatePath } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';

import type { FilterGroup } from 'src/types/followUpInspirations';
import type { Survey } from 'src/types/survey';
import { apiPaths } from 'src/services/api/apiPaths';
import HttpService from 'src/services/api/http';

export const useFilterGroupsQuery = (survey: Survey | undefined) => {
  const { i18n } = useTranslation();
  const endpoint = generatePath(apiPaths.FOLLOW_UP_INSPIRATIONS.FILTER_GROUPS);

  return useQuery<FilterGroup[]>({
    queryKey: [endpoint, survey, i18n.language],
    enabled: !!survey,
    queryFn: ({ signal }) =>
      HttpService.get(endpoint, {}, true, { signal })
        .then((data) => Promise.resolve(data.data))
        .catch(({ response }) => Promise.reject(response.status)),
  });
};

export default useFilterGroupsQuery;
